var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolicyIssuance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12572",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12573",
    d: "M10 18v4h4v-4",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12574",
    d: "M6 12h1",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12575",
    d: "M17.5 8h-11A3.5 3.5 0 003 11.5V17a1 1 0 001 1h16a1 1 0 001-1v-5.5A3.5 3.5 0 0017.5 8z",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12576",
    d: "M14 5v7",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12577",
    d: "M14 2h5v3h-5z",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12578",
    d: "M14 11.625a.375.375 0 10.376.375.376.376 0 00-.376-.375",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12579",
    d: "M6.5 8a3.5 3.5 0 013.5 3.5V18",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgPolicyIssuance;


//////////////////
// WEBPACK FOOTER
// ./src/icons/policyIssuance.svg
// module id = 857
// module chunks = 101